import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Router} from '@angular/router';
import {Subscription as RxJsSubscription} from 'rxjs';
import {ErrorService} from '@app/services';
import {Credit} from '../../credit';
import {CreditService} from '../../credit.service';
@Component({
  selector: 'hpf-credit-edit',
  templateUrl: './credit-edit.component.html'
})
export class CreditEditComponent implements OnInit, OnDestroy {
  /** The credit */
  credit = new Credit();
  /** The credit */
  private id: string;
  /** The id subscription */
  private idSubscription: RxJsSubscription;
  /** Constructor */
  constructor(private route: ActivatedRoute,
              private router: Router,
              private errorService: ErrorService,
              private creditService: CreditService) {}
  /** Init */
  ngOnInit() {
    // Get the credit after reading the id
    this.idSubscription = this.route.params.subscribe(params => {
        this.id = params['id'];
        this.refresh();
    });
  }
  /** Destroy */
  ngOnDestroy() {
    this.idSubscription.unsubscribe();
  }
  /** Fetch credit from API */
  private refresh() {
    this.creditService.get(this.id, { _populate: ['*'] })
      .then((credit: Credit) => {
        this.credit.fromObject(credit.toObject());
      })
      .catch((error) => this.errorService.handle(error));
  }
  /** Called when the credit is updated */
  onUpdate(): void {
    this.refresh();
  }
  /** Called when the credit is deleted */
  onDelete(): void {
    this.router.navigateByUrl('/credit')
      .catch((error) => this.errorService.handle(error));
  }
}
